export enum Position {
  KEEPER = 1,
}
